import Cookies from 'js-cookie';
import apiSlice from './apiSlice';

const apiSliceWithTag = apiSlice.enhanceEndpoints({ addTagTypes: ['Profile'] });

const apiProfileSlice = apiSliceWithTag.injectEndpoints({
  endpoints: (builder) => ({
    getProfile: builder.query({
      query: () => 'profile/me',
      providesTags: ['Profile'],
    }),
    editProfile: builder.mutation({
      query: (body) => ({
        url: 'profile/me',
        method: 'PATCH',
        body,
        headers: {
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Profile'],
    }),
  }),
});

export const { useGetProfileQuery, useEditProfileMutation } = apiProfileSlice;

export default apiProfileSlice;
